import React from "react";
import Paper from "@material-ui/core/Paper";
import BrowserContent from "./subsections/Browser";

function Content(props) {
  const { activeSubsection, client } = props;

  let pageContent;
  switch (activeSubsection || 0) {
    case 0: {
      pageContent = <BrowserContent client={client} />;
      break;
    }
    case 1: {
      pageContent = (
        <iframe
          title="TensorBoard"
          src="https://tensorboard.meads-ls.margagl.io/"
          style={{
            border: "unset",
            width: "100%",
            minHeight: "650px",
            minWidth: "650px"
          }}
        />
      );
      break;
    }
    default: {
      pageContent = <div>Select Subsection in Header</div>;
    }
  }

  return <Paper>{pageContent}</Paper>;
}

export default Content;



// WEBPACK FOOTER //
// ./src/sections/models/Content.js